import pagesService from "@/api/services/pagesService";
import { getTld } from "@/utils/urlHelper.ts";
import { Meta } from "@/interfaces/Pages/Meta.ts";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default ({ to }: MiddlewareInterface) => {
  pagesService.seo().then((res: Meta) => {
    const mandatoryMeta = ["title", "description", "keywords"];
    const metas = ["robots", ...mandatoryMeta] as (keyof Meta)[];
    metas.forEach((key) => {
      let meta = document.querySelector(`meta[name="${key}"]`);
      let value = res[key];

      // todo - think how to customize more general
      if (!value && key === "title" && typeof to.meta.title === "function") {
        value = to.meta.title();
      } else if (!value && key === "robots" && to.fullPath.indexOf("lecker_blog") > -1 && getTld() !== "ch") {
        value = "noindex";
      }

      if (!value) {
        if (meta && !mandatoryMeta.includes(key)) {
          document.head.removeChild(meta);
        }

        return;
      }

      if (!meta) {
        meta = document.createElement("meta");
        document.head.appendChild(meta);
        meta.setAttribute("name", key);
      }

      meta.setAttribute("content", value);
    });
    let canonicalLink = document.querySelector("link[rel=canonical]");

    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      document.head.appendChild(canonicalLink);
      canonicalLink.setAttribute("rel", "canonical");
    }

    const domainParts = location.hostname.split(".");
    const mainDomain = domainParts.slice(-2).join(".");
    canonicalLink.setAttribute("href", `${location.protocol}//${mainDomain}${location.pathname}`);
  });
};
